import useResources from "../../../hooks/UseResources";
import * as GlobalMedicalReportService from "../../../services/GlobalReportService";

/**
 * @returns array or null
 */
export default function useGlobalMedicalReports() {
    return useResources(GlobalMedicalReportService.getAllGlobalMedicalReports, "data");
}
